import { Row, Col, Steps, Input, Select, DatePicker } from 'antd'
import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import {
  RightOutlined,
  InfoCircleOutlined,
  EyeOutlined,
  EditOutlined,
} from '@ant-design/icons'
import ColorList from '../../constants/color.constants'
import Information from './components/Information'
import Skill from './components/Skill'
import Role from './components/Role'
import { updateSkill, ACCOUNT_DELETE_API } from 'api/Project/skill'
import {
  getResultAllSprintFlow,
  getResultSubTask,
  getChart,
  getChartSource,
} from 'api/Project/sprintFlow'
import Taskflow from './components/Taskflow'
import { Layout, Modal } from 'antd'
import { useParams } from 'react-router-dom'
import KPIFinance from './components/Kpifinance'
import Supportneed from './components/Supportneed'
import '../../styleLess/signature/stepmenu.scss'
import 'styleLess/signature/skill.scss'
import 'styleLess/signature/createproject.scss'
import { getCookie } from 'helper/cookie'
import { getListProjectRole } from 'api/Project/role'
import { getProjectById } from 'api/Project/project'

import { useHistory } from 'react-router-dom'
import { getauthorityUser } from 'api/Account/permission'
import { getCurrentLog } from 'api/ActivityLog/projectlog'
//checkrole
import { CounterContext } from 'redux/Golbalvalues'

//newImport arnon
import ButtonStatus from './components/common/ButtonStatus'
import ModalSaveChange from 'common/Project/modalSaveChange'
import lang from 'lang/en'

//newImport arnon

const { Step } = Steps
const { TextArea } = Input
const { Option } = Select
const { RangePicker } = DatePicker

const Container = styled.div``
const Container2 = styled.div``
const EditStep = styled(Steps)``
const HandmakeStep = styled.div``
const initialState = {
  switchComponents: 'information',
  syncFuntion: '',
  data: [],
  isLoading: true,
}
const StepOtherstate = styled.div``
let GO_STEP = 0
let cursor = ''
const CreateProjectStep1 = () => {
  const [checkBtn, setCheckBtn] = useState('')
  const [not_step, setNot_step] = useState(false)
  const [Current, SetCurrent] = useState(0)
  const [dataProject, setDataProject] = useState(initialState.data)
  const [isLoading, setIsLoading] = useState(initialState.isLoading)
  const [switchComponents, setSwitchComponents] = useState(initialState.switchComponents)
  const [visibleRegister, setVisibleRegister] = useState(true)
  const token = getCookie('access_token_admin')
  const language = getCookie('lang')
  const word = lang[language]
  const company_id = getCookie('companyId_project')
  const [eventStyle, setEvenStyle] = useState(true)
  const history = useHistory()
  const { id } = useParams()
  const [focus, setFocus] = useState(0)
  const [sendmail, setSendmail] = useState(false)
  const [roleIdauthority, setRoleIdauthority] = useState(initialState.data)
  const [checkLanding, setCheckLanding] = useState(false)
  const [dataReason, setDataReason] = useState(initialState.data)
  const [visibleReason, setVisibleReason] = useState(false)

  //check permission
  const [canKPIFinance, setCanKPIFinance] = useState(false)
  const [canSprintTaskFlow, setCanSprintTaskFlow] = useState(false)
  const [memberRole, setMemberRole] = useState()
  const [planTaskSubTaskSuccess, setPlanTaskSubTaskSuccess] = useState([])

  const [permissionBtnStatus, setPermissionBtnStatus] = useState({
    approve: false,
    creator: false,
    leader: false,
    flow_complete: false,
    planTaskSubTaskSuccess: false,
    done_percent: false,
    wordErr: '',
  })
  // const [form] = Form.useForm()

  const [checkChangeFlow, setCheckChangeFlow] = useState(0)
  const [wordErrFlow, setWordErrFlow] = useState([])

  //check approval
  const [projectHaveApproval, setProjectHaveApproval] = useState(false)
  // loading
  const [loadingTitle, setLoadingTitle] = useState(true)
  const [followStep, setFollowStep] = useState(0)
  //check role
  const {
    adminPermission,
    setPathActive,
    pathActive,
    setDirty,
    isDirty,
    click_path,
    setClick_path,
    form,
  } = useContext(CounterContext)
  const [permission, setPermission] = useState({
    menu_id: 0,
    create: false,
    read: false,
    update: false,
    delete: false,
  })

  const [checkClickStep, setCheckClickStep] = useState()

  let roleUser = parseInt(getCookie('roleUser'))
  let idEditPRJ = getCookie('idPRJ')
  let canNotEditProject = false
  let checkCanEditProjectByStatus = true
  const [checkStatusWaiting, setCheckStatusWaiting] = useState(false)
  if (id) {
    idEditPRJ = id
  }
  const urlPage = window.location.href
  const split = urlPage.split('/')

  useEffect(() => {
    let checkPermission = false
    adminPermission?.map((item) => {
      checkPermission = true
      if (roleUser === 1) {
        setPermission((prevState) => ({
          //Adminstrator
          ...prevState,
          menu_id: 3,
          create: true,
          read: true,
          update: true,
          delete: true,
        }))
      } else if (roleUser === 9) {
        //Viewer VIP ดูได้อย่างเดียว
        setPermission((prevState) => ({
          ...prevState,
          menu_id: 3,
          create: false,
          read: true,
          update: true,
          delete: false,
        }))
      } else {
        if (item.menu_id === 2 || item.menu_id === 3 || item.menu_id === 25) {
          //  2 project list  -------  3 project list all
          checkPermission = true
          setPermission((prevState) => ({
            ...prevState,
            menu_id: item.menu_id,
            create: item.create == 'Y' ? true : false,
            read: item.read == 'Y' ? true : false,
            update: item.update == 'Y' ? true : false,
            delete: item.delete == 'Y' ? true : false,
          }))
        }
      }
    })
    if (!checkPermission && adminPermission.length > 0) {
      history.push('/no-permission')
    }
  }, [adminPermission])

  useEffect(() => {
    if (
      dataProject.status_id === 3 ||
      dataProject.status_id === 5 ||
      dataProject.status_id === 8
    ) {
      setCheckStatusWaiting(true)
    }
  }, [dataProject])
  //check permission ****************

  // console.log(permission.menu_id)
  if (permission.menu_id === 3) {
    // all project list
    if (permission.read && !permission.create && !permission.update) {
      // console.log(' case:1')
      canNotEditProject = true
    } else if (permission.update) {
      // console.log(' case:2')
      canNotEditProject = false
    } else if (permission.create && !permission.update) {
      // console.log(' case:3')
      if (split[3]) {
        let landing = ''
        landing = split[3]
        if (landing === 'create-project') {
          canNotEditProject = false
        } else {
          if ([2, 3, 19].includes(dataProject.status_id)) {
            canNotEditProject = false
          } else {
            canNotEditProject = true
          }
        }
      }
    } else {
      canNotEditProject = false
    }
  } else if (permission.menu_id === 2) {
    if (permission.read && !permission.create && !permission.update) {
      canNotEditProject = true
    } else if (permission.create && !permission.update) {
      if (split[3]) {
        let landing = ''
        landing = split[3]
        if (landing === 'create-project') {
          canNotEditProject = false
        } else {
          if ([2, 3, 19].includes(dataProject.status_id)) {
            canNotEditProject = false
          } else {
            canNotEditProject = true
          }
        }
      }
    } else if (permission.update) {
      if ([3, 5, 7, 8, 9, 19, 21, 28].includes(dataProject.status_id)) {
        canNotEditProject = true
      } else {
        canNotEditProject = false
      }
    } else {
      canNotEditProject = false
    }
  }

  const stepType = () => {
    if (canNotEditProject === true) {
      return (
        <div>
          <StepOtherstate className='stepotherstate'>
            <div
              className={eventStyle && focus == 0 ? 'step-item' : 'active-step-item'}
              onClick={(e) => only_nextcomponents(0)}
            >
              <h4>{word['Project_Information']}</h4>
            </div>
            <div
              className={eventStyle && focus == 1 ? 'step-item' : 'active-step-item'}
              onClick={(e) => only_nextcomponents(1)}
            >
              <h4>{word['Project_Skills']}</h4>
            </div>
            <div
              className={eventStyle && focus == 2 ? 'step-item' : 'active-step-item'}
              onClick={(e) => only_nextcomponents(2)}
            >
              <h4>{word['Project_Role']}</h4>
            </div>
            <div
              className={eventStyle && focus == 3 ? 'step-item' : 'active-step-item'}
              onClick={(e) => only_nextcomponents(3)}
            >
              <h4>{word['Project_KPI_Finance']}</h4>
            </div>
            <div
              className={eventStyle && focus == 4 ? 'step-item' : 'active-step-item'}
              onClick={(e) => only_nextcomponents(4)}
            >
              <h4>{word['Support_need']}</h4>
            </div>
            <div
              className={eventStyle && focus == 5 ? 'step-item' : 'active-step-item'}
              onClick={(e) => only_nextcomponents(5)}
            >
              <h4>{word['Sprint_Task_Flow']}</h4>
            </div>
          </StepOtherstate>
          <div className='forshow-tab-responsive'>
            <Row className='tab-responsive-scroll-create-project'>
              <div
                className={eventStyle && focus == 0 ? 'Tabbar' : 'active-Tabbar'}
                onClick={(e) => only_nextcomponents(0)}
              >
                <h3 style={{ flexWrap: 'nowrap' }}>{word['Project_Information']}</h3>
              </div>
              <div
                className={eventStyle && focus == 1 ? 'Tabbar' : 'active-Tabbar'}
                onClick={(e) => only_nextcomponents(1)}
              >
                <h3>{word['Project_Skills']}</h3>
              </div>
              <div
                className={eventStyle && focus == 2 ? 'Tabbar' : 'active-Tabbar'}
                onClick={(e) => only_nextcomponents(2)}
              >
                <h3>{word['Project_Role']}</h3>
              </div>
              <div
                className={eventStyle && focus == 3 ? 'Tabbar' : 'active-Tabbar'}
                onClick={(e) => only_nextcomponents(3)}
              >
                <h3>{word['Project_KPI_Finance']}</h3>
              </div>
              <div
                className={eventStyle && focus == 4 ? 'Tabbar' : 'active-Tabbar'}
                onClick={(e) => only_nextcomponents(4)}
              >
                <h3>{word['Support_need']}</h3>
              </div>
              <div
                className={eventStyle && focus == 5 ? 'Tabbar' : 'active-Tabbar'}
                onClick={(e) => only_nextcomponents(5)}
              >
                <h3>{word['Sprint_Task_Flow']}</h3>
              </div>
            </Row>
          </div>
        </div>
      )
    } else {
      if (checkClickStep === 1 || checkClickStep === undefined) {
        cursor = 'no-drop'
      } else {
        cursor = 'pointer'
      }
      return (
        <div>
          <EditStep
            className='font-step'
            direction='vertical'
            current={Current}
            style={{
              paddingTop: 20,
              height: 400,
              color: ColorList.darkgray,
            }}
          >
            <Step
              title={<h4>{word['Project_Information']}</h4>}
              number='1'
              steptype='complete'
              style={{ cursor: cursor, color: ColorList.white }}
              onClick={(e) => step_nextcomponents(0)}
              status='process'
            />
            <Step
              number='2'
              title={<h4>{word['Project_Skills']}</h4>}
              steptype='focus'
              style={{ cursor: cursor }}
              onClick={(e) => step_nextcomponents(1)}
              status={followStep >= 1 ? 'process' : 'wait'}
            />

            <Step
              number='3'
              title={<h4>{word['Project_Role']}</h4>}
              steptype='empty'
              style={{ cursor: cursor }}
              onClick={(e) => step_nextcomponents(2)}
              status={followStep >= 2 ? 'process' : 'wait'}
            />
            <Step
              number='4'
              title={<h4>{word['Project_KPI_Finance']}</h4>}
              style={{ cursor: cursor }}
              steptype='empty'
              onClick={(e) => step_nextcomponents(3)}
              status={followStep >= 3 ? 'process' : 'wait'}
            />
            <Step
              title={<h4>{word['Support_need']}</h4>}
              style={{ cursor: cursor }}
              number='5'
              onClick={(e) => step_nextcomponents(4)}
              status={followStep >= 4 ? 'process' : 'wait'}
            />
            <Step
              title={<h4>{word['Sprint_Task_Flow']}</h4>}
              style={{ cursor: cursor }}
              steptype='empty'
              number='6'
              onClick={(e) => step_nextcomponents(5)}
              status={followStep >= 5 ? 'process' : 'wait'}
            />
          </EditStep>
          <div className='for-scroll-handmake-step-content'>
            <HandmakeStep className='handmake-step-content'>
              <div
                className={eventStyle && focus >= 0 ? 'step-item' : 'active-step-item'}
                onClick={(e) => step_nextcomponents(0)}
              >
                <div className='circle-number'>
                  <p>1</p>
                </div>
                <div className='line1'></div>
                <span className='small'>{word['Project_Information']}</span>
              </div>
              <div
                className={eventStyle && focus >= 1 ? 'step-item' : 'active-step-item'}
                onClick={(e) => step_nextcomponents(1)}
              >
                <div className='circle-number'>
                  <p>2</p>
                </div>
                <div className='line2'></div>
                <span className='small'>{word['Project_Skills']}</span>
              </div>
              <div
                className={eventStyle && focus >= 2 ? 'step-item' : 'active-step-item'}
                onClick={(e) => step_nextcomponents(2)}
              >
                <div className='circle-number'>
                  <p>3</p>
                </div>
                <div className='line3'></div>
                <span className='small'>{word['Project_Role']}</span>
              </div>

              <div
                className={eventStyle && focus >= 3 ? 'step-item' : 'active-step-item'}
                onClick={(e) => step_nextcomponents(3)}
              >
                <div className='circle-number'>
                  <p>4</p>
                </div>
                <div className='line4'></div>
                <span className='small'>{word['Project_KPI_Finance']}</span>
              </div>
              <div
                className={eventStyle && focus >= 4 ? 'step-item' : 'active-step-item'}
                onClick={(e) => step_nextcomponents(4)}
              >
                <div className='circle-number'>
                  <p>5</p>
                </div>
                <div className='line5'></div>
                <span className='small'> {word['Support_need']}</span>
              </div>
              <div
                className={eventStyle && focus >= 5 ? 'step-item' : 'active-step-item'}
                onClick={(e) => step_nextcomponents(5)}
              >
                <div className='circle-number'>
                  <p>6</p>
                </div>
                <div className='line6'></div>
                <span className='small'>{word['Sprint_Task_Flow']}</span>
              </div>
            </HandmakeStep>
          </div>
        </div>
      )
    }
  }

  const [focus_page, setFocus_page] = useState(true)
  const [visibleSaveChange, setVisibleSaveChange] = useState(false)
  const [visibleSaveDraft, setVisibleSaveDraft] = useState(false)
  const checkLandingPage = () => {
    const urlPage = window.location.href
    const split = urlPage.split('/')
    let landing = ''
    if (split[5]) {
      landing = split[5]
      if (landing === 'information') {
        setFocus_page('information')
        SetCurrent(0)
        setFocus(0)
        setFollowStep(0)
        return setSwitchComponents('information')
      } else if (landing === 'skill') {
        setFocus_page('skill')
        SetCurrent(1)
        setFocus(1)
        setFollowStep(1)
        return setSwitchComponents('skill')
      } else if (landing === 'role') {
        SetCurrent(2)
        setFocus(2)
        setFollowStep(2)
        return setSwitchComponents('role')
      } else if (landing === 'kpi') {
        SetCurrent(3)
        setFocus(3)
        setFollowStep(3)
        return setSwitchComponents('kpi')
      } else if (landing === 'supportneed') {
        SetCurrent(4)
        setFocus(4)
        setFollowStep(4)
        return setSwitchComponents('supportneed')
      } else if (landing === 'sprintflow') {
        SetCurrent(5)
        setFocus(5)
        setFollowStep(5)
        return setSwitchComponents('sprintflow')
      }
      setCheckLanding(true)
    }
  }
  useEffect(() => {
    if (checkLanding === false) {
      checkLandingPage()
    }
  }, [urlPage])

  const swithCaseFunction = (type) => {
    setSwitchComponents(type)
    if (type === 'information') {
      SetCurrent(0)
      setFocus(0)
      setFollowStep(0)
    } else if (type === 'skill') {
      SetCurrent(1)
      setFocus(1)
      setFollowStep(1)
    } else if (type === 'role') {
      SetCurrent(2)
      setFocus(2)
      setFollowStep(2)
    } else if (type === 'kpi') {
      SetCurrent(3)
      setFocus(3)
      setFollowStep(3)
    } else if (type === 'supportneed') {
      SetCurrent(4)
      setFocus(4)
      setFollowStep(4)
    } else if (type === 'sprintflow') {
      SetCurrent(5)
      setFocus(5)
      setFollowStep(5)
    }
  }

  const only_nextcomponents = (value) => {
    GO_STEP = value
    SwitchAll()
  }

  // @@@@@@@@@@@@@@@@@ skill page function @@@@@@@@@@@@@@@@@@@@

  const [pastnewData, setPastnewData] = useState(initialState.data)
  const [warningModalskill, setWarningModalskill] = useState(false)
  const [disLoadPage, setDisLoadPage] = useState(false)
  const [holdtime, setHoldtime] = useState(true)
  const step_nextcomponents = (value) => {
    GO_STEP = value
    if (value === 0) {
      setFocus_page('information')
    } else if (value === 1) {
      setFocus_page('skill')
      setHoldtime(false)
    } else {
      setFocus_page('')
    }
    if (
      ![0, 1].includes(value) &&
      pastnewData.length == 0 &&
      disLoadPage === true &&
      canNotEditProject === false &&
      dataProject.status_id < 6 &&
      focus_page === 'skill'
    ) {
      setWarningModalskill(true)
    } else {
      if (focus_page === 'skill') {
        SwitchAll()
        go_save_and_changpage()
      } else if (focus_page === 'information') {
        checkDataInfoChange(value)
      } else {
        SwitchAll()
        setDisLoadPage(false)
      }
    }
  }
  const functionalOK_event = () => {
    setWarningModalskill(false)
    SwitchAll()
    go_save_and_changpage()
  }
  const functionalCancle_event = () => {
    setWarningModalskill(false)
    setFocus_page('skill')
  }
  const checkDataskill_Func = (inValueCase) => {
    setHoldtime(false)

    if (inValueCase === 'next') {
      GO_STEP = 2

      if (canNotEditProject === false) {
        if (pastnewData.length == 0) {
          if (disLoadPage === true) {
            if (dataProject.status_id < 6) {
              setWarningModalskill(true)
            } else {
              SwitchAll()
              go_save_and_changpage()
            }
          } else {
            setHoldtime(true)
            SwitchAll()
          }
        } else {
          if (disLoadPage === true) {
            go_save_and_changpage()
          } else {
            setHoldtime(true)
          }

          history.push(`/project/${id}/role`)
          swithCaseFunction('role')
          SwitchAll()
        }
      } else {
        setHoldtime(true)
        SwitchAll()
      }
    } else if (inValueCase === 'previous') {
      GO_STEP = 0
      if (canNotEditProject === false) {
        if (pastnewData.length == 0) {
          if (disLoadPage === true) {
            go_save_and_changpage()
          }
          SwitchAll()
        } else {
          if (disLoadPage === true) {
            go_save_and_changpage()
          } else {
            setHoldtime(true)
          }
          history.push(`/project/${idEditPRJ}/information`)
          swithCaseFunction('information')

          SwitchAll()
        }
      } else {
        SwitchAll()
      }
    }
  }

  const go_save_and_changpage = () => {
    if (disLoadPage === true) {
      let ListID = []
      for (var i = 0; i < pastnewData.length; i++) {
        if (pastnewData[i].id != null) {
          ListID.push(pastnewData[i].id)
        }
      }
      const dataArray = {
        id: idEditPRJ,
        project_skill: `${ListID}`,
      }

      try {
        updateSkill({
          params: dataArray,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            try {
              ACCOUNT_DELETE_API({
                params: dataArray,
                token: token,
              }).then((res2) => {
                if (res2.status === 200) {
                  setHoldtime(true)
                  setDisLoadPage(false)
                }
              })
            } catch (error) {
              console.log(error)
            }
          } else {
            setHoldtime(true)
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else {
      setHoldtime(true)
    }
  }
  const checkDataInfoChange = (step) => {
    if (isDirty && step !== 0) {
      setVisibleSaveChange(true)
    } else {
      SwitchAll()
    }
  }

  // @@@@@@@@@@@@@@@@@ skill page function @@@@@@@@@@@@@@@@@@@@
  const SwitchAll = async () => {
    if (checkClickStep !== 1 && checkClickStep !== undefined) {
      if (GO_STEP == 0) {
        SetCurrent(0)
        setFocus(0)
        setFollowStep(0)
        setFocus_page('information')
        history.push(`/project/${idEditPRJ}/information`)
        return setSwitchComponents('information')
      } else if (GO_STEP == 1) {
        SetCurrent(1)
        setFocus(1)
        setFollowStep(1)
        setFocus_page('skill')
        history.push(`/project/${idEditPRJ}/skill`)
        return setSwitchComponents('skill')
      } else if (GO_STEP == 2) {
        SetCurrent(2)
        setFocus(2)
        setFollowStep(2)
        history.push(`/project/${idEditPRJ}/role`)
        return setSwitchComponents('role')
      } else if (GO_STEP == 3) {
        SetCurrent(3)
        setFocus(3)
        setFollowStep(3)
        history.push(`/project/${idEditPRJ}/kpi`)
        return setSwitchComponents('kpi')
      } else if (GO_STEP == 4) {
        SetCurrent(4)
        setFocus(4)
        setFollowStep(4)
        history.push(`/project/${idEditPRJ}/supportneed`)
        return setSwitchComponents('supportneed')
      } else if (GO_STEP == 5) {
        SetCurrent(5)
        setFocus(5)
        setFollowStep(5)
        history.push(`/project/${idEditPRJ}/sprintflow`)
        return setSwitchComponents('sprintflow')
      }
    }
  }

  useEffect(() => {
    if (checkChangeFlow === 'Y') {
      setPermissionBtnStatus((prevState) => ({
        ...prevState,
        flow_complete: true,
      }))
    } else {
      setPermissionBtnStatus((prevState) => ({
        ...prevState,
        flow_complete: false,
      }))
    }
    setPermissionBtnStatus((prevState) => ({
      ...prevState,
      wordErr: wordErrFlow,
    }))
  }, [checkChangeFlow, wordErrFlow])

  //เช็คเติม plan date task,subtask
  const checkPlandateTaskSubTask = async () => {
    setPlanTaskSubTaskSuccess([])
    await getResultAllSprintFlow({
      project_id: parseInt(idEditPRJ),
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          data.map((itemtask) => {
            if (itemtask.plan_start == '') {
              setPlanTaskSubTaskSuccess((prev) => [...prev, 'Task:' + itemtask.title])
            }
            getResultSubTask({
              level_id: parseInt(itemtask.id),
              project_id: parseInt(idEditPRJ),
              token: token,
            })
              .then(async (response) => {
                const { status, data, error } = response

                if (error) {
                  setIsLoading(false)
                  return true
                }
                if (status === 200) {
                  data.map((item) => {
                    if (item.plan_start == '') {
                      setPlanTaskSubTaskSuccess((prev) => [
                        ...prev,
                        `Task:${itemtask.title} =>` + ' SubTask:' + item.title,
                      ])
                    }
                  })

                  setIsLoading(false)
                } else {
                  setIsLoading(false)
                  return true
                }
              })
              .catch((error) => {
                setIsLoading(false)
                console.error(error)
              })
          })

          setIsLoading(false)
        } else {
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setIsLoading(false)
        console.error(error)
      })
  }
  useEffect(() => {
    if (planTaskSubTaskSuccess.length == 0) {
      setPermissionBtnStatus((prevState) => ({
        ...prevState,
        planTaskSubTaskSuccess: true,
      }))
    } else {
      setPermissionBtnStatus((prevState) => ({
        ...prevState,
        planTaskSubTaskSuccess: false,
      }))
    }
  }, [planTaskSubTaskSuccess])

  // cal api projectById
  const getListDataProjectById = async () => {
    await getProjectById({
      id: idEditPRJ,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setDataProject([])
          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          setCheckClickStep(data.status_id)
          if (data.done_percent === 100) {
            setPermissionBtnStatus((prevState) => ({
              ...prevState,
              done_percent: true,
            }))
          } else {
            setPermissionBtnStatus((prevState) => ({
              ...prevState,
              done_percent: false,
            }))
          }
          if (data.complete_flow === 'Y') {
            setPermissionBtnStatus((prevState) => ({
              ...prevState,
              flow_complete: true,
            }))
          } else {
            setPermissionBtnStatus((prevState) => ({
              ...prevState,
              flow_complete: false,
            }))
          }

          await getauthorityUser({
            id: idEditPRJ,
            token: token,
          })
            .then(async (response) => {
              if (error) {
                await setIsLoading(false)
                return true
              }
              if (status === 200) {
                if (data.account_id === response.data.id) {
                  setPermissionBtnStatus((prevState) => ({
                    ...prevState,
                    creator: true,
                  }))
                } else {
                  setPermissionBtnStatus((prevState) => ({
                    ...prevState,
                    creator: false,
                  }))
                }
                if (response.data.role_id === 1) {
                  setPermissionBtnStatus((prevState) => ({
                    ...prevState,
                    leader: true,
                  }))
                } else {
                  setPermissionBtnStatus((prevState) => ({
                    ...prevState,
                    leader: false,
                  }))
                }

                var str4 = response.data.permission
                var keySearch = 4
                if (str4.includes(keySearch)) {
                  setPermissionBtnStatus((prevState) => ({
                    ...prevState,
                    approve: true,
                  }))
                } else {
                  setPermissionBtnStatus((prevState) => ({
                    ...prevState,
                    approve: false,
                  }))
                }
              } else {
                return true
              }
            })
            .catch((error) => {
              console.error(error)
            })
          await setDataProject(data)
          await setIsLoading(false)
          await setLoadingTitle(false)
          CheckStatusProjectFunctional(data)
        } else {
          setDataProject([])
          setIsLoading(false)
          setLoadingTitle(false)
          return true
        }
      })
      .catch((error) => {
        setLoadingTitle(false)
        setDataProject([])
        setIsLoading(false)
        console.error(error)
      })
  }
  // call api  ListMember
  const getDataMember = async () => {
    await getListProjectRole({
      project_id: idEditPRJ,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (data[0].member != null) {
          setVisibleRegister(false)
        } else {
          setVisibleRegister(true)
        }
        let projecthaveapproval = false
        data.map((item) => {
          // console.log(item)
          if (item.member != null) {
            item.member.map((item2) => {
              let split = item2.permission.split(',')
              split.map((item3) => {
                if (item3 == 4) {
                  projecthaveapproval = true
                }
              })
            })
          }
        })
        setProjectHaveApproval(projecthaveapproval)
        if (error) {
          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          await setIsLoading(false)
        } else {
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setIsLoading(false)
        console.error(error)
      })
  }

  // call api role id
  const getroleAuthority = async () => {
    await getauthorityUser({
      id: idEditPRJ,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setRoleIdauthority([])

          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          await setRoleIdauthority(data)
          await setIsLoading(false)

          var str = data.permission
          var keySearch = 3
          if (str.includes(keySearch) || roleUser == 1 || roleUser == 9) {
            setCanKPIFinance(true)
          } else {
            setCanKPIFinance(false)
          }

          var str2 = data.permission
          var keySearch2 = 2
          if (str2.includes(keySearch2) || roleUser == 1 || roleUser == 9) {
            setCanSprintTaskFlow(true)
          } else {
            setCanSprintTaskFlow(false)
          }
          setMemberRole(data.role_id)
        } else {
          setRoleIdauthority([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setRoleIdauthority([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const getCurrentLogProject = async () => {
    await getCurrentLog({
      project_id: idEditPRJ,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataReason([])

          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataReason(data[0])
          setIsLoading(false)
        } else {
          setDataReason([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataReason([])
        setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      setPathActive('/project-list')
      checkPlandateTaskSubTask()
      getDataMember()
      getListDataProjectById()
      stepType()
      getCurrentLogProject()
      getroleAuthority()
      getChartData()
      return () => {
        getDataMember()
      }
    }
  }, [token])

  const showNameProject = (namePRJ) => {
    if (namePRJ) {
      return (
        <>
          {dataProject.id} - {namePRJ}
        </>
      )
    } else {
      return 'Create New Project'
    }
  }
  const goProjectList = () => {
    if (isDirty) {
      setNot_step(true)
      setVisibleSaveChange(true)
      setClick_path('/project-list')
    } else {
      history.push({
        pathname: '/project-list',
      })
      setClick_path()
    }
  }
  const showStatus = (statusName, statusId) => {
    if (statusId && statusId != 1) {
      return (
        <div
          className={`tagStatus ${statusId === 2
            ? 'status-draft'
            : statusId === 3
              ? 'status-waiting-register'
              : statusId === 4
                ? 'status-register'
                : statusId === 5
                  ? 'status-waiting-kickoff'
                  : statusId === 6
                    ? 'status-kickoff'
                    : statusId === 7
                      ? 'status-hold'
                      : statusId === 8
                        ? 'status-waiting-complete'
                        : statusId === 9
                          ? 'status-complete'
                          : statusId === 21
                            ? 'status-complete-delay'
                            : statusId === 28
                              ? 'status-waiting-hold'
                              : 'status-cancel'
            }`}
        >
          <div>{statusName}</div>
        </div>
      )
    }
  }
  const CheckStatusProjectFunctional = (data) => {
    if (
      data.status_id == 4 ||
      data.status_id == 5 ||
      data.status_id == 6 ||
      data.status_id == 8 ||
      data.status_id == 9
    ) {
      setSendmail(true)
    } else {
      setSendmail(false)
    }
  }
  const colorStatus = (item) => {
    return item.status_id === 3
      ? 'status-InProgress-color'
      : item.status_id === 4
        ? 'status-InProgress-color'
        : item.status_id === 5
          ? 'status-InProgress-color'
          : item.status_id === 6
            ? 'status-InProgress-color'
            : item.status_id === 7 || item.status_id === 27
              ? 'status-Open-color'
              : item.status_id === 8
                ? 'status-Done-color'
                : item.status_id === 9
                  ? 'status-Done-color'
                  : [11, 12, 19, 26].includes(item.status_id)
                    ? 'status-Cancel-color'
                    : item.status_id === 21
                      ? 'status-Cancel-color'
                      : 'status-InProgress-color'
  }
  const handleViewReason = (data) => {
    setVisibleReason(true)
  }
  const modalReason = () => {
    return (
      <Modal
        maskClosable={false}
        className='ModalSaveDraft'
        visible={visibleReason}
        onOk={() => setVisibleReason(false)}
        onCancel={() => setVisibleReason(false)}
      >
        <EditOutlined
          className={`Icon-style ${colorStatus(dataReason)}`}
          style={{ paddingTop: 16 }}
        />
        <h2 style={{ marginBottom: 16 }}>{dataReason.event_msg} project reason</h2>
        <TextArea
          style={{ cursor: 'unset' }}
          value={dataReason.message}
          readOnly
        ></TextArea>
      </Modal>
    )
  }

  const [fullyCheckComplete, setFullyCheckComplete] = useState(false)

  //checkchart
  const [checkStartEnd, setCheckStartEnd] = useState(false)
  const [checkTask200, setCheckTask200] = useState(false)
  const [checkTask400, setCheckTask400] = useState(false)
  const [checkDecision200, setCheckDecision200] = useState(false)
  const [checkDecision400, setCheckDecision400] = useState(false)
  const [checkDecision2200, setCheckDecision2200] = useState(false)
  const [checkDecision2400, setCheckDecision2400] = useState(false)
  const [checkHaveDecision, setCheckHaveDecision] = useState(false)
  const [errrr, serErrrr] = useState([])

  const getChartData = async () => {
    setCheckTask400(false)
    setCheckDecision400(false)
    setCheckDecision200(false)
    setCheckDecision2200(false)
    setCheckDecision2400(false)
    setCheckHaveDecision(false)
    serErrrr([])

    await getChart({
      project_id: parseInt(idEditPRJ),
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setIsLoading(false)
          return true
        }

        if (status === 200) {
          //เช็คว่ามี start กับ end
          let checkStart = false
          let checkEnd = false
          data.nodes.map((item) => {
            if (item.label == 'Start') {
              checkStart = true
            }
            if (item.label == 'End') {
              checkEnd = true
            }
          })
          let a = false

          if (checkStart == true && checkEnd == true) {
            a = true
          } else {
            a = false
          }
          if (checkStart == false) {
            serErrrr((prev) => [...prev, 'Please check start point'])
          }
          if (checkEnd == false) {
            serErrrr((prev) => [...prev, 'Please check end point'])
          }

          // เช็คว่า start มีเส้นออกมั้ย กับ end มีเส้นเข้ามั้ย
          let checkLineStart = false
          let checkLineEnd = false
          data.nodes.map((item) => {
            if (data.edges != null) {
              if (item.label == 'Start') {
                data.edges.map((item2) => {
                  if (item.id == item2.source) {
                    checkLineStart = true
                  }
                })
              }
              if (item.label == 'End') {
                data.edges.map((item2) => {
                  if (item.id == item2.target) {
                    checkLineEnd = true
                  }
                })
              }
            } else {
              checkLineStart = false
              checkLineEnd = false
            }
          })
          let b = false
          if (checkLineStart == true && checkLineEnd == true) {
            b = true
          } else {
            b = false
          }

          if (checkLineStart == false) {
            if (checkStart == true) {
              serErrrr((prev) => [...prev, 'Please check connector'])
            }
          }
          if (checkLineEnd == false) {
            if (checkEnd == true) {
              serErrrr((prev) => [...prev, 'Please check connector'])
            }
          }

          //เช็ครวม
          if (a == true && b == true) {
            setCheckStartEnd(true)
          } else {
            setCheckStartEnd(false)
          }

          //เช็คว่า task นั้นมีเส้นออกหรือเข้ามั้ย
          data.nodes.map((item) => {
            if (item.shape != 'flow-circle') {
              if (item.shape == 'flow-rect') {
                getChartSource({
                  id_chart: item.id,
                  project_id: parseInt(idEditPRJ),
                  token: token,
                })
                  .then(async (response) => {
                    const { status, data, error } = response
                    if (error) {
                      setIsLoading(false)
                      return true
                    }
                    if (status === 200) {
                      setCheckTask200(true)
                    } else {
                      serErrrr((prev) => [...prev, 'Please check connector'])

                      setCheckTask400(true)
                    }
                  })
                  .catch((error) => {
                    setIsLoading(false)
                    console.error(error)
                  })
              } else {
                //เช็คว่า decision นั้นมีเส้นออกทั้ง 2 เส้นมั้ย
                setCheckHaveDecision(true)
                getChartSource({
                  id_chart: item.id,
                  project_id: parseInt(idEditPRJ),
                  token: token,
                })
                  .then(async (response) => {
                    const { status, data, error } = response

                    if (error) {
                      setIsLoading(false)
                      return true
                    }
                    if (status === 200) {
                      if (data.length == 2 || data.length == 3) {
                        setCheckDecision200(true)
                        setCheckDecision2200(true)
                      } else {
                        serErrrr((prev) => [
                          ...prev,
                          'Please check connector for decision',
                        ])
                        setCheckDecision2400(true)
                      }
                    } else {
                      serErrrr((prev) => [...prev, 'Please check connector for decision'])

                      setCheckDecision400(true)
                    }
                  })
                  .catch((error) => {
                    setIsLoading(false)
                    console.error(error)
                  })
              }
            }
          })
          setIsLoading(false)
        } else {
          serErrrr((prev) => [...prev, 'ไม่มี task'])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        serErrrr((prev) => [...prev, 'ไม่มี task'])

        setIsLoading(false)
        console.error(error)
      })
  }

  const checkChartComplete = (
    check,
    check2,
    check22,
    check5,
    check55,
    check7,
    check77,
  ) => {
    let check3 = false
    if (check2 == true && check22 == false) {
      check3 = true
    } else {
      check3 = false
    }

    let check6 = false
    if (check5 == true && check55 == false) {
      check6 = true
    } else {
      check6 = false
    }

    let check8 = false
    if (check7 == true && check77 == false) {
      check8 = true
    } else {
      check8 = false
    }
    let check4 = false

    if (checkHaveDecision == false) {
      check6 = true
      check8 = true
    }
    if (check == true && check3 == true && check6 == true && check8 == true) {
      check4 = 'Y'
    } else {
      check4 = 'N'
    }
    setFullyCheckComplete(check4)
  }

  useEffect(() => {
    checkChartComplete(
      checkStartEnd,
      checkTask200,
      checkTask400,
      checkDecision200,
      checkDecision400,
      checkDecision2200,
      checkDecision2400,
    )
  }, [
    checkStartEnd,
    checkTask200,
    checkTask400,
    checkDecision200,
    checkDecision400,
    checkDecision2200,
    checkDecision2400,
  ])

  const renderComponents = (value) => {
    switch (switchComponents) {
      case 'skill':
        return (
          <Skill
            idEditPRJ={idEditPRJ}
            role={canNotEditProject}
            swithCaseFunction={swithCaseFunction}
            visibleRegister={visibleRegister}
            statusProject={`${dataProject.status_id}`}
            projectHaveApproval={projectHaveApproval}
            company_id={company_id}
            checkDataskill_Func={checkDataskill_Func}
            setPastnewData={setPastnewData}
            setDisLoadPage={setDisLoadPage}
            form={form}
          />
        )
      case 'role':
        return (
          <Role
            idEditPRJ={idEditPRJ}
            getDataMemberStep1={getDataMember}
            role={canNotEditProject}
            swithCaseFunction={swithCaseFunction}
            visibleRegister={visibleRegister}
            company_id={company_id}
            statusProject={`${dataProject.status_id}`}
            getroleAuthority={getroleAuthority}
            projectHaveApproval={projectHaveApproval}
            holdtime={holdtime}
            form={form}
            setVisibleSaveDraft={setVisibleSaveDraft}
            checkBtn={checkBtn}
          />
        )
      case 'kpi':
        return (
          <KPIFinance
            canKPIFinance={canKPIFinance}
            idEditPRJ={idEditPRJ}
            role={canNotEditProject}
            swithCaseFunction={swithCaseFunction}
            visibleRegister={visibleRegister}
            statusProject={`${dataProject.status_id}`}
            projectHaveApproval={projectHaveApproval}
            userCanApprove={permissionBtnStatus}
            form={form}
            setVisibleSaveDraft={setVisibleSaveDraft}
            checkBtn={checkBtn}
          />
        )
      case 'supportneed':
        return (
          <Supportneed
            memberRole={memberRole}
            idEditPRJ={idEditPRJ}
            checkCanEditProjectByStatus={checkCanEditProjectByStatus}
            canNotEditProject={canNotEditProject}
            swithCaseFunction={swithCaseFunction}
            visibleRegister={visibleRegister}
            statusProject={`${dataProject.status_id}`}
            sendmailStatus={sendmail}
            authorityId={roleIdauthority.role_id}
            projectHaveApproval={projectHaveApproval}
            checkStatusWaiting={checkStatusWaiting}
            form={form}
            setVisibleSaveDraft={setVisibleSaveDraft}
            checkBtn={checkBtn}
          />
        )
      case 'sprintflow':
        return (
          <Taskflow
            memberRole={memberRole}
            canSprintTaskFlow={canSprintTaskFlow}
            canKPIFinance={canKPIFinance}
            idEditPRJ={idEditPRJ}
            canNotEditProject={canNotEditProject}
            swithCaseFunction={swithCaseFunction}
            visibleRegister={visibleRegister}
            statusProject={`${dataProject.status_id}`}
            sendmailStatus={sendmail}
            projectHaveApproval={projectHaveApproval}
            setCheckChangeFlow={setCheckChangeFlow}
            checkChangeFlow={checkChangeFlow}
            checkPlandateTaskSubTask={checkPlandateTaskSubTask}
            setWordErrFlow={setWordErrFlow}
            checkStatusWaiting={checkStatusWaiting}
            form={form}
            setVisibleSaveDraft={setVisibleSaveDraft}
            checkBtn={checkBtn}
            fullyCheckComplete={fullyCheckComplete}
            setFullyCheckComplete={setFullyCheckComplete}
          />
        )
      default:
        return (
          <Information
            permission={permission}
            statusId={dataProject?.status_id}
            idEditPRJ={idEditPRJ}
            role={canNotEditProject}
            swithCaseFunction={swithCaseFunction}
            visibleRegister={visibleRegister}
            refreshDataProject={getListDataProjectById}
            statusProject={`${dataProject.status_id}`}
            projectHaveApproval={projectHaveApproval}
            checkCanEditProjectByStatus={checkCanEditProjectByStatus}
            form={form}
            setVisibleSaveDraft={setVisibleSaveDraft}
            switchStep={SwitchAll}
            setFocusPage={setFocus_page}
            setCheckBtn={setCheckBtn}
            checkBtn={checkBtn}
            setDirty={setDirty}
            click_path={click_path}
            setClick_path={setClick_path}
            setPermissionBtnStatus={setPermissionBtnStatus}
            fullyCheckComplete={fullyCheckComplete}
          />
        )
    }
  }

  useEffect(() => {
    getDataMember()
    // renderComponents()
    window.scrollTo(0, 0)
  }, [switchComponents])
  // console.log(permission.update, projectHaveApproval)
  return (
    <Container className='createproject-main-container'>
      <div
        className='BreadCrumb'
        style={{ visibility: loadingTitle ? 'hidden' : '', maxWidth: '50%' }}
      >
        <h4 className='level1' onClick={goProjectList}>
          Project
        </h4>
        <RightOutlined className='icon-style' />
        <h4 className='level2 cutter-text-line-1'>{showNameProject(dataProject.name)}</h4>
      </div>

      <Row
        className='row-item-nameproject-and-button'
        style={{
          visibility: loadingTitle ? 'hidden' : '',
        }}
      >
        <Row className='row-left'>
          <h1 className='cutter-text-line-1 no-breadcrumb' style={{ color: '#000' }}>
            {showNameProject(dataProject.name)}
          </h1>
          <div className='box-status'>
            {showStatus(dataProject.status, dataProject.status_id)}
          </div>
          <div
            hidden={dataReason.message ? false : true}
            className='viewreason-div'
            style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'nowrap',
              minWidth: 'fit-content',
            }}
          >
            <EyeOutlined className='eyeOutlined' onClick={handleViewReason} />
            <p className='small viewreason' onClick={handleViewReason}>
              click to view reason
            </p>
          </div>
        </Row>

        {(permission.update || permissionBtnStatus.approve) && (
          <ButtonStatus
            status={dataProject.status}
            setCheckBtn={setCheckBtn}
            visibleRegister={visibleRegister}
            visibleSaveDraft={visibleSaveDraft}
            setVisibleSaveDraft={setVisibleSaveDraft}
            status_id={`${dataProject.status_id}`}
            idEditPRJ={idEditPRJ}
            projectHaveApproval={projectHaveApproval}
            userCanApprove={permissionBtnStatus}
            form={form}
            permission={permission}
          />
        )}
      </Row>

      <Container2 className='createproject-container'>
        <Col className='step-content'>{stepType()}</Col>

        <Col className='body-content' style={{ margin: 0, padding: 32 }}>
          {renderComponents()}
        </Col>
      </Container2>
      <Modal
        maskClosable={false}
        className='edit-width-skill'
        visible={warningModalskill}
        onOk={functionalOK_event}
        okText={'Confirm'}
        centered
        onCancel={functionalCancle_event}
      >
        <div className='body-modal'>
          <InfoCircleOutlined className='Icon-style' />
          <h2 style={{ textAlign: 'center' }}>Add New Professional Skills</h2>

          <h4 style={{ textAlign: 'center' }}>
            Are you sure to create the new project without identify professional skills ?
          </h4>
        </div>
      </Modal>
      <ModalSaveChange
        SwitchAll={SwitchAll}
        setFocus_page={setFocus_page}
        form={form}
        visibleSaveChange={visibleSaveChange}
        setVisibleSaveChange={setVisibleSaveChange}
        setClick_path={setClick_path}
        state={'information'}
        not_step={not_step}
        path={click_path}
      />
      {modalReason()}
    </Container>
  )
}
export default CreateProjectStep1
